import { api } from './api';
import type { TrendingTrack, TrendingTrackHistory } from '../types';

export const trendingMusicApi = {
  listTracks: (params: { platform?: string; sort?: string; limit?: number; offset?: number; niche?: string; month?: string } = {}) => {
    const q = new URLSearchParams();
    if (params.platform) q.set('platform', params.platform);
    if (params.sort) q.set('sort', params.sort);
    if (params.limit != null) q.set('limit', String(params.limit));
    if (params.offset != null) q.set('offset', String(params.offset));
    if (params.niche) q.set('niche', params.niche);
    if (params.month) q.set('month', params.month);
    return api.get<{ tracks: TrendingTrack[]; total: number }>(`/trending-music/tracks?${q}`);
  },

  syncTracks: (limit = 50, country?: string) => {
    const q = new URLSearchParams({ limit: String(limit) });
    if (country) q.set('country', country);
    return api.post<{ new_tracks: number; updated_tracks: number; total_tracks: number; total_cost: number }>(
      `/trending-music/sync?${q}`,
      {},
    );
  },

  addManualTrack: (url: string) =>
    api.post<TrendingTrack>('/trending-music/tracks/manual', { url }),

  updateTrack: (id: number, updates: Partial<TrendingTrack>) =>
    api.patch<TrendingTrack>(`/trending-music/tracks/${id}`, updates),

  deleteTrack: (id: number) =>
    api.delete<{ status: string }>(`/trending-music/tracks/${id}`),

  getTrackHistory: (id: number, limit = 30) =>
    api.get<{ history: TrendingTrackHistory[] }>(`/trending-music/tracks/${id}/history?limit=${limit}`),

  getStats: () =>
    api.get<{ total: number; licensed: number; new_this_week: number }>('/trending-music/stats'),

  classifyTracks: () =>
    api.post<{ status: string }>('/trending-music/classify', {}),

  getTrackNiches: (id: number) =>
    api.get<{ niches: Array<{ id: number; music_id: number; niche: string; score: number; source: string }> }>(`/trending-music/tracks/${id}/niches`),

  setTrackNiche: (id: number, niche: string, score: number) =>
    api.post<{ status: string; track_id: number; niche: string; score: number }>(`/trending-music/tracks/${id}/niches`, { niche, score }),

  listNiches: () =>
    api.get<{ niches: string[] }>('/trending-music/niches'),

  getSuggestions: (niche: string, limit = 3) =>
    api.get<{ tracks: TrendingTrack[]; niche: string }>(`/trending-music/suggestions?niche=${encodeURIComponent(niche)}&limit=${limit}`),

  getSyncStatus: () =>
    api.get<{ last_sync: string | null; interval_hours: number }>('/trending-music/sync-status'),

  getAvailableMonths: () =>
    api.get<{ months: string[] }>('/trending-music/months'),
};
